import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
} from '../../../route';

const CreatePurchaseOrderPage = lazyRouteComponent(
  () => import('./CreatePurchaseOrderPage'),
  'CreatePurchaseOrderPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/procurement/purchase-orders/new',
  staticData: {
    app: {
      access: {
        modulesAnyOf: [ProductModule.PROCUREMENT],
        permissionsAllOf: [
          { action: Action.Read, subject: Subject.PurchaseOrder },
          { action: Action.Create, subject: Subject.PurchaseOrder },
        ],
      },
    },
  },
  component: CreatePurchaseOrderPage,
  loader: () => ({
    crumb: msg('Create Purchase Order', { context: 'page breadcrumb' }),
    crumbAncestors: [
      {
        title: msg('Purchase Order Status', { context: 'page breadcrumb' }),
        path: '/procurement/purchase-orders',
      },
    ],
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.PROCUREMENT],
    });
  },
});
